var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useRenameCSS } from "../theme/Theme.js";
import { composeEventHandlers } from "../util/composeEventHandlers.js";
import { isElementInteractiveTarget } from "./Table.utils.js";
export const Row = forwardRef((_a, ref) => {
    var { className, selected = false, shadeOnHover = true, onClick, onRowClick } = _a, rest = __rest(_a, ["className", "selected", "shadeOnHover", "onClick", "onRowClick"]);
    const { cn } = useRenameCSS();
    const handleRowClick = (event) => {
        if (!onRowClick) {
            return;
        }
        if (isElementInteractiveTarget(event.target)) {
            return;
        }
        onRowClick(event);
    };
    return (React.createElement("tr", Object.assign({}, rest, { ref: ref, className: cn("navds-table__row", className, {
            "navds-table__row--selected": selected,
            "navds-table__row--shade-on-hover": shadeOnHover,
        }), onClick: composeEventHandlers(onClick, handleRowClick), "data-interactive": !!onRowClick })));
});
export default Row;
//# sourceMappingURL=Row.js.map